import { ADMIN, ROLES, SUBROLES } from "MODULES/users/constants";
import { properCase } from "../../lib/formatters/text";

export const subroleLabel = (role, subrole) => {
  if (!subrole) return null;
  return properCase(subrole.replace(`${role}_`, ""));
};

export const hasRole = (user = {}, role) =>
  user.role === role ||
  (user.permissions && user.permissions.includes(role)) ||
  user.role === ADMIN;

export const hasPermission = (user, permission) =>
  (user.permissions && user.permissions.includes(permission)) ||
  user.role === ADMIN;

export const hasSubRole = (user, subrole) =>
  user.subrole === subrole ||
  (user.permissions && user.permissions.includes(subrole));

export const hasAnyOfSubroles = (user, subroles) => {
  const hasPermissions = user.permissions
    ? user.permissions.filter(p => subroles.includes(p))
    : [];
  return (
    subroles.includes(user.subrole) ||
    hasPermissions.length > 0 ||
    user.role === ADMIN
  );
};

export const hasAnyOfRoles = (user, roles) => {
  const hasPermissions = user.permissions
    ? user.permissions.filter(p => roles.includes(p))
    : [];

  return (
    roles.includes(user.role) ||
    hasPermissions.length > 0 ||
    user.role === ADMIN
  );
};

export const hasAnyOfRolesOrSubroles = (user, roles, subroles) =>
  hasAnyOfRoles(user, roles) || hasAnyOfSubroles(user, subroles);

export const disableIfHasAnyOfRoles = (user, roles) => {
  if (user.role === ADMIN) return false;
  const otherRolesNotInSelectedRoles =
    roles && ROLES.filter(a => !roles.some(s => s.includes(a)));

  const otherRoles =
    user.permissions && roles
      ? user.permissions.filter(
          a => ROLES.includes(a) && otherRolesNotInSelectedRoles.includes(a)
        )
      : [];

  return roles && roles.includes(user.role) && otherRoles.length === 0;
};

export const disableIfHasAnyOfSubroles = (user, subroles) => {
  if (user.role === ADMIN) return false;
  const otherRolesNotInSubroles =
    subroles && ROLES.filter(a => !subroles.some(s => s.includes(a)));

  const otherRolesAndSubroles =
    user.permissions && subroles
      ? user.permissions.filter(
          a =>
            (SUBROLES.includes(a) && !subroles.includes(a)) ||
            (ROLES.includes(a) && otherRolesNotInSubroles.includes(a))
        )
      : [];

  return (
    subroles &&
    subroles.includes(user.subrole) &&
    otherRolesAndSubroles.length === 0
  );
};

export const disableIfHasAnyOfRolesOrSubroles = (
  user,
  roles = [],
  subroles = []
) => {
  if (user.role === ADMIN) return false;

  const otherRolesNotInSubroles = ROLES.filter(
    a => !subroles.some(s => s.includes(a))
  );

  const otherRolesNotInRoles = ROLES.filter(r => !roles.includes(r));

  const otherRolesAndSubroles =
    user.permissions && subroles
      ? user.permissions.filter(
          a =>
            (SUBROLES.includes(a) && !subroles.includes(a)) ||
            (ROLES.includes(a) &&
              otherRolesNotInSubroles.includes(a) &&
              otherRolesNotInRoles.includes(a))
        )
      : [];

  return (
    (subroles.includes(user.subrole) || roles.includes(user.role)) &&
    otherRolesAndSubroles.length === 0
  );
};



// WEBPACK FOOTER //
// ./app/modules/users/helpers.js